import gsap from 'gsap';
import { Sizes } from '../utils';

export class BouncingItem {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			power: options?.power || 3,
			duration: options.duration || 0.5,
			inner: options?.inner,
			innerPower: options?.innerPower || 5,
			innerDuration:
				options.innerDuration || options.innerDuration === 0
					? options.innerDuration
					: 0.8,
		};
		this.isEnable = false;

		this.gsapDefaults = {};
		this.inners = [];
		this.moveFuncs = [];
		this.leaveFuncs = [];
		this.xTo = [];
		this.yTo = [];
		this.innerXto = [];
		this.innerYto = [];
	}

	init() {
		if ( ! this.elements?.length ) return;
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.gsapDefaults.ease = 'expo.out';
			this.gsapDefaults.duration = this.options.duration;
			this.elements.forEach( ( item, index ) => {
				this.xTo[ index ] = gsap.quickTo(
					item,
					'x',
					this.gsapDefaults
				);
				this.yTo[ index ] = gsap.quickTo(
					item,
					'y',
					this.gsapDefaults
				);
				if ( this.options.inner ) {
					this.inners[ index ] = item.children;
					this.innerXto[ index ] = gsap.quickTo(
						this.inners[ index ],
						'x',
						this.gsapDefaults
					);
					this.innerYto[ index ] = gsap.quickTo(
						this.inners[ index ],
						'y',
						this.gsapDefaults
					);
				} else {
					this.inners[ index ] = null;
				}
				this.moveFuncs[ index ] = ( e ) =>
					this.#move(
						e,
						item,
						this.xTo[ index ],
						this.yTo[ index ],
						this.innerXto[ index ],
						this.innerYto[ index ]
					);
				this.leaveFuncs[ index ] = () =>
					this.#leave(
						this.xTo[ index ],
						this.yTo[ index ],
						this.innerXto[ index ],
						this.innerYto[ index ]
					);
				item.addEventListener( 'mousemove', this.moveFuncs[ index ] );
				item.addEventListener( 'mouseleave', this.leaveFuncs[ index ] );
			} );
			this.isEnable = true;
		}
	}

	kill() {
		this.elements.forEach( ( item, index ) => {
			item.removeEventListener( 'mousemove', this.moveFuncs[ index ] );
			item.removeEventListener( 'mouseleave', this.leaveFuncs[ index ] );
			gsap.killTweensOf( item );
			gsap.killTweensOf( this.inners[ index ] );
			this.xTo[ index ] = null;
			this.yTo[ index ] = null;
			this.innerXto[ index ] = null;
			this.innerYto[ index ] = null;
			gsap.set( [ item, this.inners[ index ] ], { clearProps: 'all' } );
		} );
		this.gsapDefaults = {};
		this.inners = [];
		this.moveFuncs = [];
		this.leaveFuncs = [];
		this.xTo = [];
		this.yTo = [];
		this.innerXto = [];
		this.innerYto = [];
		this.isEnable = false;
	}

	resize() {
		if ( this.isEnable ) {
			this.kill();
		}
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.init();
		}
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.gsapDefaults = null;
		this.inners = null;
		this.moveFuncs = null;
		this.leaveFuncs = null;
		this.xTo = null;
		this.yTo = null;
		this.innerXto = null;
		this.innerYto = null;
		this.isEnable = null;
	}

	#leave = ( xTo, yTo, innerXto, innerYto ) => {
		xTo( 0 );
		yTo( 0 );
		if ( innerXto && innerYto ) {
			innerXto( 0 );
			innerYto( 0 );
		}
	};

	#move = ( e, item, xTo, yTo, innerXto, innerYto ) => {
		const bounding = item.getBoundingClientRect();
		const posX = e.clientX - bounding.left - item.offsetWidth / 2;
		const posY = e.clientY - bounding.top - item.offsetHeight / 2;
		xTo( posX * 0.2 * this.options.power );
		yTo( posY * 0.2 * this.options.power );
		if ( innerXto && innerYto ) {
			innerXto( posX * 0.1 * this.options.innerPower );
			innerYto( posY * 0.1 * this.options.innerPower );
		}
	};
}
